var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoaded)?_c('tf-table',_vm._b({on:{"changeFilter":function($event){return _vm.updateQueryParams('filters', $event)},"changeSortCriteria":_vm.changeSortCriteria},scopedSlots:_vm._u([(_vm.error)?{key:"error",fn:function(){return [_vm._v(" "+_vm._s(_vm.error)+" ")]},proxy:true}:null,{key:"parentRow",fn:function(ref){
var rowData = ref.rowData;
return _c('tf-table-parent-row',{key:rowData.id},[_c('tf-table-td',[_c('router-link',{attrs:{"to":{
            name: 'ProjectOverview',
            params: {
              projectId: rowData.id,
              view: 'product',
            }
          }}},[_c('tf-button',{attrs:{"type":"primary","size":"text"}},[_vm._v(" "+_vm._s(rowData.type)+" ")])],1)],1),_c('tf-table-td',[_c('ul',_vm._l((rowData.products),function(product){return _c('li',{key:product,domProps:{"textContent":_vm._s(product)}})}),0)]),_c('tf-table-td',[_vm._v(" "+_vm._s(_vm.$TF.DatesUtils.formatSimpleDate(rowData.due_date, 'MM/DD/YY') || '—')+" ")])],1)}}],null,true)},'tf-table',{
      filterValues: _vm.$route.query.filters,
      parentalControls: true,
      pageLimit: 100,
      tableData: _vm.tableData,
      tableMeta: {
        columns: _vm.columns,
        sort: {
          direction: _vm.$route.query.sortDirection || 'asc',
          prop: _vm.$route.query.sortProp || 'type',
        }
      },
    },false)):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }